import * as http from '../util/request'
/**
 * 测试
 * @param {object} data   
 */


/**
 * @description: 
 * @param {*} query
 * @return {*}
 */
const login = (query) => {
  console.log(query)
  return http.post(`oauth/user/token?password=${query.password}&username=${query.username}`, query)
}

const ossFileUpdate = (query) => {
  return http.post('/aliyunOss/uploadFile', query)
}

export {
  login,
  ossFileUpdate
}
